import React, { Component } from "react";
import InsertionOrderDataStore from "../../../../Flux/Stores/InsertionOrderDataStore";
import BookFiltersStore from "../../../../Flux/Stores/BookFiltersStore";
import { fetchOnlyInsertionOrders, setFilteredData, deleteInsertionOrders, pushIOToDV360, updateIOSyncStatus } from "../../../../Flux/Actions/InsertionOrderActions";
import { setFilteredIO, deleteChildLineItems, fetchOnlyLineItemConfig, fetchOnlyLineItems, triggerLineItemModal } from "../../../../Flux/Actions/LineItemActions";
import TableHelper from "../../../../Components/Table/TableHelper";
import DataNotFound from "../../../Modals/DataNotFound";
import MasterCampaignsStore from "../../../../Flux/Stores/MasterCampaignsStore";
import NewInsertionOrder from "../../../Modals/NewInsertionOrder";
import EditInsertionOrder from "../../../Modals/EditInsertionOrder";
import DeleteInsertionOrder from "../../../Modals/DeletePlatformModal";
import FindReplaceModal from "../../../Modals/FindReplaceModal";
import ClonePlatformModal from "../../../Modals/ClonePlatformModal";
import LoadingIcon from "../../../../Components/LoadingSpinner";
import { TOOLBAR_MODE, EDIT_BUTTON_LOCATION } from "@acadia-ui/toolbar";
import { COLUMNS } from "../../../../Components/ShowHideColumns";
import WorkbookStore from "../../../../Flux/Stores/WorkbookStore";
import Table from "../../../../Components/Table/Table";
import _ from "lodash";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import applyFindReplaceToTable from "../applyFindReplaceToTable";
import FullFiltersSidesheet, { fullFilterAlgorithm } from "../FullFiltersSidesheet";
import { showToast, ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import { draftHLISelected } from "../../../../Helpers/ActionHelpers";

class LegacyInsertionOrderView extends Component {
	constructor() {
		super();
		this.state = {
			isHidden: true,
			selectedRow: {},
			insertionsOrderToDelete: [],
			readOnly: true,
			selectedCount: 0,
			selectedRows: [],
			success: false,
			successMessage: null,
			delete: false,
			singleSelected: false,
			multipleSelected: false,
			draftSelected: false,
			searchValue: "",
			dv360APIEnabled: false,
			advancedFilter: false,
			displayFilter: false,
			displayDV360StatusFilter: false,
			extraColumns: [],
			search: ""
		};
		this.dataTableApi = React.createRef();
		this.filterChoices = BookFiltersStore.getChoicesState();
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
	}

	getInsertionOrders = () => {
		const insertionOrderData = InsertionOrderDataStore.getData();
		let siteOptions = null;
		if (InsertionOrderDataStore.getConfig().InsertionOrderData !== undefined) {
			InsertionOrderDataStore.getConfig().InsertionOrderData.forEach((option) => {
				if (option.Name === "PlatformSiteID") {
					siteOptions = option.Options;
				}
			});
		}
		if (siteOptions !== null) {
			insertionOrderData.forEach((insertionorder) => {
				if (insertionorder.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (insertionorder.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						insertionorder.PlatformSiteID = platformName;
					}
				}
			});
		}
		this.setState({
			insertionOrderConfig: InsertionOrderDataStore.getConfig(),
			insertionOrderData: InsertionOrderDataStore.getData(),
			loading: false,
			isHidden: false
		});
	};

	componentDidMount = () => {
		this.getInsertionOrders();
		this.setEnabledColumns();

		InsertionOrderDataStore.on("insertionorder_success", this.gridChanged);
		InsertionOrderDataStore.on("insertionorder_edit_success", this.insertionOrderEdited);
		InsertionOrderDataStore.on("insertionorder_deleted", this.insertionOrderDeleted);
		InsertionOrderDataStore.on("insertionorder__childCountUpdated", this.gridChanged);
		InsertionOrderDataStore.on("sync_status_updated", () => this.gridChanged(true));
		InsertionOrderDataStore.on("create_and_add_children_success", this.gridChanged);
		BookFiltersStore.on("fetchSyncStatusesSuccess", this.toggleDV360API);
		BookFiltersStore.on("fetchSyncStatusesFailure", this.toggleDV360API);
		WorkbookStore.on("enabled_columns_fetched", this.setEnabledColumns);
		this.toggleDV360API();
	};

	componentWillUnmount = () => {
		InsertionOrderDataStore.removeListener("insertionorder_success", this.gridChanged);
		InsertionOrderDataStore.removeListener("insertionorder_edit_success", this.insertionOrderEdited);
		InsertionOrderDataStore.removeListener("insertionorder_deleted", this.insertionOrderDeleted);
		InsertionOrderDataStore.removeListener("insertionorder__childCountUpdated", this.gridChanged);
		InsertionOrderDataStore.removeListener("sync_status_updated", () => this.gridChanged(true));
		InsertionOrderDataStore.removeListener("create_and_add_children_success", this.gridChanged);
		BookFiltersStore.removeListener("fetchSyncStatusesSuccess", this.toggleDV360API);
		BookFiltersStore.removeListener("fetchSyncStatusesFailure", this.toggleDV360API);
		WorkbookStore.removeListener("enabled_columns_fetched", this.setEnabledColumns);
	};

	componentDidUpdate = (prevProps, prevState) => {
		if (!_.isEqual(prevState.extraColumns, this.state.extraColumns)) {
			// force rerender of table
			this.setState({ isHidden: true }, () => {
				this.setState({ isHidden: false });
			});
		}
	};

	setEnabledColumns = () => {
		const syncStatus = BookFiltersStore?.getSyncStatuses()?.find(({ MasterPlatformID }) => MasterPlatformID == this.props?.campaignMetaData?.PlatformID)?.SyncStatus;

		const enabledColumns = syncStatus ? COLUMNS.DV360 : [];

		enabledColumns.push(COLUMNS.IsDraft);

		const auditLevel = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "InsertionOrder")?.AuditLevelID;
		const Preferences = WorkbookStore.getEnabledColumns()?.find(({ HierarchyLevelID }) => HierarchyLevelID == auditLevel)?.Preferences;
		const parsedPreferences = Preferences ? JSON.parse(Preferences) : null;
		if (parsedPreferences && parsedPreferences instanceof Object) {
			this.setState({
				extraColumns: enabledColumns.map(({ id, name, selected }) => ({
					id,
					name,
					selected: parsedPreferences?.[id] ?? selected
				}))
			});
		} else {
			this.setState({ extraColumns: enabledColumns });
		}
	};

	toggleDV360API = () => {
		const statuses = BookFiltersStore.getSyncStatuses();
		if (statuses) {
			const { SyncStatus } = statuses.find(({ MasterPlatformID }) => MasterPlatformID === 2);
			const validStatusIDs = [3, 6];
			let platformPKExists = false;
			if (this.props.campaignMetaData?.PlatformCampaignPK) {
				try {
					platformPKExists = JSON.parse(this.props.campaignMetaData.PlatformCampaignPK).some((platform) => {
						return platform.MasterPlatformID === 2 && platform.PlatformPK;
					});
				} catch {
					console.log("PlatformCampaignPK is not in JSON format");
				}
			}
			this.setState(
				{
					dv360APIEnabled: SyncStatus && validStatusIDs.includes(this.props.campaignMetaData.ExternalSystemStatusID) && platformPKExists,
					displayDV360StatusFilter: SyncStatus
				},
				() => {
					this.setEnabledColumns();
				}
			);
		}
	};

	sendToDV360 = () => {
		const insertionOrderIDs = [];
		this.state.selectedRows.forEach((row) => {
			insertionOrderIDs.push(row.InsertionOrderID);
		});
		pushIOToDV360(insertionOrderIDs)
			.then(() => {
				showToast("workbookToasts", <ToastNotification type="success" message="Insertion orders sent to DV360." timed={5000} />);
			})
			.catch(async (error) => {
				const errorObject = await error.details.json();
				if (errorObject?.Errors) {
					errorObject.Errors.forEach((errorMessage) => {
						showToast("workbookToasts", <ToastNotification type="error" message={errorMessage} />);
					});
				} else {
					showToast("workbookToasts", <ToastNotification type="error" message="Insertion order(s) not sent, please review" />);
				}
			});
		this.setState(
			{
				selectedCount: 0,
				singleSelected: false,
				multipleSelected: false,
				loading: true
			},
			() => {
				updateIOSyncStatus(insertionOrderIDs);
				setTimeout(() => {
					const auditLevelArray = [];
					this.props.auditLevelData.forEach((auditLevel) => {
						auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
					});
					const choices = JSON.parse(JSON.stringify(this.filterChoices));
					let auditLevelChoice = null;
					auditLevelArray.forEach((auditLevel) => {
						if (auditLevel.label === "InsertionOrder") {
							auditLevelChoice = auditLevel;
						}
					});
					if (auditLevelChoice !== null) {
						choices.auditlevel = auditLevelChoice;
						fetchOnlyInsertionOrders(choices, this.parentCampaignUniqueID).catch(() => {
							this.setState({ loading: false });
						});
					}
				}, 20000);
			}
		);
	};

	handleNavigate = () => {
		setTimeout(() => {
			if (InsertionOrderDataStore.getNavigate()) {
				this.setState({ loading: false }, () => {
					// this.navigateAfterCreation();
					this.props.navigateToLineItems();
					setTimeout(() => {
						triggerLineItemModal();
					}, 1000);
				});
			}
		}, 0);
	};

	insertionOrderDeleted = () => {
		// const selectedLine = this.state.selectedRows[0];
		// setTimeout(() => {
		// 	deleteChildLineItems(selectedLine.InsertionOrderID);
		// 	this.fetchLineItemConfig();
		// }, 0);
		this.props.updateCounts().then(() => {
			this.gridChanged();
		});
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Insertion Order deleted successfully." timed={5000} />);
	};

	insertionOrderEdited = () => {
		setTimeout(() => {
			this.fetchLineItemConfig();
		}, 0);
		this.gridChanged();
	};

	openModal = () => {
		this.newInsertionOrderModal.triggerOpenClose();
	};

	setSelectedRow = (callback) => {
		const selectedLine = this.state.selectedRows[0];
		const dataArr = {};
		Object.keys(selectedLine).forEach((key) => {
			if ((key === "EndDate" || key === "StartDate") && selectedLine[key] !== "") {
				dataArr[key] = this.formatDate(selectedLine[key]);
			} else if (key === "Cost" || key === "Budget") {
				dataArr[key] = selectedLine[key].replace(/[^\d.-]/g, "");
			} else if (key !== "UniqueID" && key !== "InsertionOrderName") {
				dataArr[key] = selectedLine[key];
			}
		});
		this.setState({ selectedRow: dataArr }, () => {
			callback?.();
		});
	};

	editInsertionOrder = () => {
		this.setSelectedRow(() => {
			this.editInsertionOrderModal.triggerOpenClose();
		});
	};

	deleteInsertionOrder = (e, row) => {
		const selectedUniqueIDs = this.state.selectedRows.map((row) => {
			return row.UniqueID;
		});
		const selectedLines = JSON.parse(JSON.stringify(InsertionOrderDataStore.getData()))
			.map((row, index) => {
				row.Row = index;
				return row;
			})
			.filter((row) => {
				return selectedUniqueIDs.includes(row.UniqueID);
			});

		this.setState({ insertionsOrderToDelete: selectedLines }, () => {
			this.deleteInsertionOrderModal.triggerOpenClose();
		});
	};

	formatDate = (date) => {
		const d = new Date(date);
		let month = String(d.getMonth() + 1);
		let day = String(d.getDate());
		const year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	};

	duplicateInsertionOrderData = () => {
		this.setSelectedRow(() => {
			this.duplicateInsertionOrder.triggerOpenClose();
		});
	};

	refetchData = () => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		let auditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "InsertionOrder") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			this.setState({ readOnly: true, searchValue: "", advancedFilter: false, displayFilter: false });
			this.props.updateCounts().then(() => {
				this.gridChanged();
			});
		}
	};

	gridChanged = (loading = false) => {
		const packData = InsertionOrderDataStore.getData();
		let siteOptions = null;
		InsertionOrderDataStore.getConfig().InsertionOrderData.forEach((option) => {
			if (option.Name === "PlatformSiteID") {
				siteOptions = option.Options;
			}
		});
		if (siteOptions !== null) {
			packData.forEach((pack) => {
				if (pack.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (pack.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						pack.PlatformSiteID = platformName;
					}
				}
			});
		}

		let preparredData;

		if (Object.keys(this.state.filterOptions ?? {})?.length > 0) {
			this?.dataTableApi?.current?.dataProvider?.update?.(packData);
			preparredData = fullFilterAlgorithm({
				handleFilter: () => {},
				config: InsertionOrderDataStore.getConfig(),
				data: InsertionOrderDataStore.getData(),
				dataTableApi: this.dataTableApi,
				filterOptions: this.state.filterOptions
			});
		} else {
			preparredData = InsertionOrderDataStore.getData();
		}

		this.setState({ insertionOrderData: preparredData, loading }, () => {
			this.props.updateMetaData();
		});
	};

	unlockSheet = () => {
		this.setState({
			readOnly: !this.state.readOnly,
			success: false,
			successMessage: null,
			delete: false
		});
	};

	lockSheet = () => {
		this.setState({
			readOnly: true,
			success: true,
			successMessage: null,
			delete: false
		});
	};

	numberSelected = (row, chk, selectAll = false) => {
		let newSelectedRows = this.state.selectedRows;
		let draftSelected = false;
		if (!selectAll) {
			if (chk) {
				newSelectedRows.push(row);
				if (row.IsDraft === "True") {
					draftSelected = true;
				}
			} else {
				newSelectedRows = newSelectedRows.filter((selectedRow) => {
					return selectedRow.UniqueID != row.UniqueID;
				});
			}
		} else {
			newSelectedRows = row;
			if (
				row.find((data) => {
					return data.IsDraft === "True";
				})
			) {
				draftSelected = true;
			}
		}
		this.setState({
			selectedRows: newSelectedRows,
			selectedCount: newSelectedRows.length,
			success: false,
			delete: false,
			singleSelected: newSelectedRows.length === 1,
			multipleSelected: newSelectedRows.length > 1,
			draftSelected
		});
	};

	returnSearchedValues = (searchTerm) => {
		const searchableFields = [];
		const filteredData = [];
		const configKeys = Object.keys(this.state.insertionOrderConfig);
		configKeys.forEach((bucket) => {
			if (Array.isArray(this.state.insertionOrderConfig[bucket])) {
				this.state.insertionOrderConfig[bucket].forEach((field) => {
					if (field.IsSummarizedHeader === true) {
						searchableFields.push(field.Name);
					}
				});
			}
		});
		this.state.insertionOrderData.forEach((data) => {
			let matchFound = false;
			for (const field of searchableFields) {
				if (data[field]) {
					if (data[field].toLowerCase().includes(searchTerm.toLowerCase())) {
						filteredData.push(data);
						matchFound = true;
						break;
					}
				}
			}
			if (matchFound === false && data.PlatformInsertionOrderPK) {
				const targetValue = JSON.parse(data.PlatformInsertionOrderPK)?.find(({ MasterPlatformID }) => MasterPlatformID == this.props?.campaignMetaData?.PlatformID);
				if (targetValue?.PlatformPK && targetValue.PlatformPK.toLowerCase().includes(searchTerm.toLowerCase())) {
					filteredData.push(data);
				}
			}
		});
		return filteredData;
	};

	clearSearch = () => {
		this.setState({
			insertionOrderData: InsertionOrderDataStore.getData(),
			searchValue: "",
			success: false,
			successMessage: null,
			advancedFilter: false,
			displayFilter: false
		});
		document.getElementById("searchInsertionOrder").value = "";
	};

	navigateAfterCreation = () => {
		if (InsertionOrderDataStore.getNavigate()) {
			const childData = InsertionOrderDataStore.getConfig().ChildData;
			const tabs = document.querySelectorAll('[role="tab"]');
			if (tabs.length > 0) {
				tabs.forEach((tab) => {
					if (tab.innerHTML.replace(/ *\([^)]*\) */g, "").replace(/\s/g, "") === childData.ChildAuditLevelName) {
						tab.click();
					}
				});
			}
		}
	};

	navigateToChild = (selected) => {
		if (selected) {
			setFilteredIO([selected.InsertionOrderName, selected.InsertionOrderID]);
			this.props.navigateToLineItems();
		}
	};

	handleDeleteInsertionOrder = (data) => {
		const postObject = TableHelper.formatPostObj({
			data,
			config: this.state.insertionOrderConfig,
			hierarchyLevel: "InsertionOrder",
			metaData: this.props.campaignMetaData,
			auditLevelID: this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "InsertionOrder")?.AuditLevelID
		});
		const deletedIDs = [];
		postObject.forEach((io) => {
			deletedIDs.push(io.InsertionOrderData.InsertionOrderID);
		});
		this.setState({ loading: true }, () => {
			deleteInsertionOrders(postObject, deletedIDs, this.refetchData);
		});
	};

	fetchLineItemConfig = (callback) => {
		const choices = JSON.parse(JSON.stringify(BookFiltersStore.getChoicesState()));
		const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		let auditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "LineItem") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			fetchOnlyLineItemConfig(choices, campaignUniqueID).then(() => {
				callback && callback();
				fetchOnlyLineItems(choices, campaignUniqueID);
			});
		} else {
			callback && callback();
		}
	};

	handleFilter = (filteredData, applyFilter, filterOptions) => {
		if (!document.getElementById("InsertionOrder_find_replace_modal")?.hasAttribute("open")) {
			if (applyFilter === true) {
				this.setState({
					insertionOrderData: filteredData,
					advancedFilter: true,
					displayFilter: false,
					filterOptions
				});
			} else if (this.state.searchValue !== "") {
				const filteredData = this.returnSearchedValues(this.state.searchValue);
				if (filteredData.length !== 0) {
					this.setState({
						insertionOrderData: filteredData,
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				} else {
					this.setState({
						insertionOrderData: InsertionOrderDataStore.getData(),
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				}
			} else {
				this.setState({
					insertionOrderData: InsertionOrderDataStore.getData(),
					advancedFilter: false,
					displayFilter: false,
					filterOptions: []
				});
			}
		}
	};

	replaceData = (data, toggleEditing = false) => {
		applyFindReplaceToTable({
			data,
			dataTableApi: this.dataTableApi,
			toggleEditing,
			syncData: (updatedData) => {
				this.setState({ insertionOrderData: updatedData });
			}
		});
	};

	handleRowSelection = (selectedRows) => {
		this.setState({
			selectedRows
		});
	};

	render() {
		// creativesConfig is for Modal
		const { insertionOrderConfig, insertionOrderData, searchValue, advancedFilter } = this.state;

		let searchTerm = null;
		if (searchValue !== "" || advancedFilter === true) {
			searchTerm = `${searchValue !== "" ? `Search Term: ${searchValue}` : "Filtered Values "}  (${
				insertionOrderData.filter((row) => {
					return row.InsertionOrderID !== null && row.InsertionOrderID !== undefined;
				}).length
			})`;
		}

		const auditLevelID = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "InsertionOrder")?.AuditLevelID;
		const TMEnabled = WorkbookStore.getIsTrafficEnabled();

		return (
			<section className="tab__container">
				{!this.state.isHidden && (
					<>
						{insertionOrderData && insertionOrderConfig && (
							<>
								{!this.state.isHidden ? (
									<Table
										ref={this.dataTableApi}
										data={insertionOrderData}
										config={insertionOrderConfig}
										hierarchyLevel="InsertionOrder"
										vanityName="Insertion Order"
										metaData={this.props.campaignMetaData}
										// updateSelected={this.numberSelected}
										updateSelected={this.handleRowSelection} // Need to eventually incorporate all the logic from numberSelected function
										refetchData={this.refetchData}
										navigateToChild={this.navigateToChild}
										search={this.state.search}
										onSearch={(searchValue) => {
											this.setState({ search: searchValue });
										}}
										// Insertion Order specific props and extra columns
										syncAPI={this.props.campaignMetaData && this.props.campaignMetaData.SyncIcon === "True"}
										extraColumns={this.state.extraColumns}
										auditLevelID={auditLevelID}
										actionBarProps={{
											filtersSideSheet: (
												<FullFiltersSidesheet
													filterOptions={this.state.filterOptions}
													hierarchyLevel="InsertionOrder"
													ref={this.dataTableApi}
													data={InsertionOrderDataStore.getData()}
													config={insertionOrderConfig}
													handleFilter={this.handleFilter}
												/>
											),
											editButton: (
												<Button
													// this comment exists to prevent eslint from making this unreadable.
													style={{ order: 2 }}
													display={BUTTON_DISPLAY.SECONDARY}
													size={BUTTON_SIZE.SMALL}
													data-tracking-id-alt="open-edit-insertion-order-details-modal"
												>
													Edit Details
												</Button>
											),
											showEditMode: EDIT_BUTTON_LOCATION.DEFAULT_MODE_ACTIONS,
											defaultModeActions: [
												<Button
													style={{ order: 1 }}
													size={BUTTON_SIZE.SMALL}
													display={BUTTON_DISPLAY.TEXT}
													key="insertionorder-find-replace"
													onClick={() => {
														this.findReplaceModal.triggerOpenClose();
													}}
													data-tracking-id-alt="open-insertion-order-find-replace-modal"
												>
													Find and Replace
												</Button>,
												<Button
													style={{ order: 3 }}
													key="add-insertion-order"
													size={BUTTON_SIZE.SMALL}
													onClick={() => {
														this.newInsertionOrderModal.triggerOpenClose();
													}}
													data-tracking-id-alt="open-add-insertion-order-modal"
												>
													Add Insertion Order
												</Button>
											],
											actions: [
												<Tooltip key="edit-insertionOrder" title="Edit" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														icon="icon-pencil"
														display={BUTTON_DISPLAY.ICON_BORDERED}
														size={BUTTON_SIZE.SMALL}
														disabled={this.state.selectedRows?.length !== 1}
														onClick={() => {
															this.editInsertionOrderModal.triggerOpenClose();
														}}
														data-tracking-id-alt="open-edit-insertion-order-modal"
													>
														Edit Insertion Order
													</Button>
												</Tooltip>,
												<Tooltip key="action-clone" title="Clone Insertion Order" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														// this comment exists to prevent eslint from making this unreadable.
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-copy"
														onClick={() => this.duplicateInsertionOrder.triggerOpenClose()}
														disabled={this.state.selectedRows?.length > 1 || draftHLISelected(this.dataTableApi)}
														data-tracking-id-alt="open-clone-insertion-order-modal"
													>
														Clone Insertion Order
													</Button>
												</Tooltip>,
												<Tooltip key="action-delete" title="Delete Insertion Order" position={TOOLTIP_POSITION.BOTTOM_START}>
													<Button
														size={BUTTON_SIZE.SMALL}
														display={BUTTON_DISPLAY.ICON_BORDERED}
														icon="icon-trash"
														onClick={this.deleteInsertionOrder}
														data-tracking-id-alt="open-delete-insertion-order-modal"
													>
														Delete Insertion Order
													</Button>
												</Tooltip>
											]
										}}
									/>
								) : (
									<LoadingIcon />
								)}
							</>
						)}
						{this.state.loading && <LoadingIcon />}

						<NewInsertionOrder
							newInsertionOrder={(ref) => {
								this.newInsertionOrderModal = ref;
							}}
							config={insertionOrderConfig}
							filters={this.filterChoices}
							metaData={this.props.campaignMetaData}
							updateCounts={this.props.updateCounts}
							fetchChildLevelConfig={this.fetchLineItemConfig}
							handleNavigate={this.handleNavigate}
							auditLevelID={auditLevelID}
						/>
						<EditInsertionOrder
							editInsertionOrder={(ref) => {
								this.editInsertionOrderModal = ref;
							}}
							config={insertionOrderConfig}
							filters={this.filterChoices}
							data={this.state.selectedRows[0] || {}}
							metaData={this.props.campaignMetaData}
							auditLevelID={auditLevelID}
						/>

						<DeleteInsertionOrder
							deletePlatformModal={(ref) => {
								this.deleteInsertionOrderModal = ref;
							}}
							type="Insertion Order"
							data={this.state.insertionsOrderToDelete}
							deleteType="deleteInsertionOrder"
							hierarchyLevel="InsertionOrder"
							handleDelete={this.handleDeleteInsertionOrder}
							onSubmit={() => {
								// this.props.updateCounts("InsertionOrder");
							}}
						>
							<div className="platformListContainer">
								<div className="platformListHeader">
									<span>Description</span>
									<span>Number of Line Items</span>
									<span>Site</span>
									<span>Start Date</span>
									<span>End Date</span>
								</div>

								{this.state.selectedRows.map((line, i) => (
									<div className="platformInfoRow" key={`deleteplatformline-${i}`}>
										<span className="platformInfo">{line.InsertionOrderName_Friendly || line.InsertionOrderDescription}</span>
										<span className="platformInfo">{line.ChildCount}</span>
										<span className="platformInfo">{line.InNameSite}</span>
										<span className="platformInfo">{line.StartDate}</span>
										<span className="platformInfo">{line.EndDate}</span>
									</div>
								))}
							</div>
						</DeleteInsertionOrder>
						<ClonePlatformModal
							clonePlatformModal={(ref) => {
								this.duplicateInsertionOrder = ref;
							}}
							data={this.state.selectedRows[0]}
							config={insertionOrderConfig}
							metaData={this.props.campaignMetaData}
							updateCounts={this.props.updateCounts}
							navigateToChild={this.props.navigateToLineItems}
							refresh={this.gridChanged}
							type="Insertion Order"
							childName="Line Item"
							auditLevelID={auditLevelID}
							liAuditLevelID={this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName == "LineItem")?.AuditLevelID}
						/>
						<FindReplaceModal
							findReplaceModal={(ref) => {
								this.findReplaceModal = ref;
							}}
							type={"InsertionOrder"}
							hierarchyLevel="InsertionOrder"
							config={insertionOrderConfig}
							data={insertionOrderData}
							replaceData={this.replaceData}
							tableRef={this.dataTableApi}
						/>
					</>
				)}
			</section>
		);
	}
}

export default LegacyInsertionOrderView;
